"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadedImageShow = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _HoveredButtonWrapperStyled = require("../styled/HoveredButtonWrapperStyled");
var _ImageContainerStyled = require("../styled/ImageContainerStyled");
var _ImgStyled = require("../styled/ImgStyled");
var _ImageBrowse = require("./ImageBrowse");
const UploadedImageShow = _ref => {
  let {
    acceptableMimeTypes,
    clientId,
    imageSrc,
    isDisabled,
    uploadedFileName,
    usageType,
    onChange
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [showChange, setShowChange] = (0, _react.useState)(false);
  const [browserOpen, setBrowserOpen] = (0, _react.useState)(false);
  const imageBrowserRef = (0, _react.useRef)(null);
  const handleMouseEnter = () => {
    if (isDisabled) return;
    setShowChange(true);
  };
  const handleMouseLeave = () => {
    if (isDisabled) return;
    setShowChange(false);
  };
  const handleOpenBrowser = () => {
    setBrowserOpen(true);
  };
  const handleCloseBrowser = (0, _react.useCallback)(() => {
    setBrowserOpen(false);
  }, []);
  const handleClickUpload = () => {
    if (isDisabled) return;
    imageBrowserRef.current?.click();
  };
  return /*#__PURE__*/_react.default.createElement(_ImageContainerStyled.ImageContainerStyled, {
    "aria-disabled": isDisabled,
    backgroundColorShow: usageType === "logo",
    onClick: handleClickUpload,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    themeMode: themeMode
  }, /*#__PURE__*/_react.default.createElement(_ImgStyled.ImgStyled, {
    alt: uploadedFileName || "Default Logo",
    "data-client-id": clientId,
    isDisabled: isDisabled,
    objectFit: usageType === "image" ? "cover" : "contain",
    src: imageSrc,
    themeMode: themeMode
  }), /*#__PURE__*/_react.default.createElement(_HoveredButtonWrapperStyled.HoveredButtonWrapperStyled, {
    visible: themeMode !== "ursa-light" && (showChange || browserOpen)
  }, /*#__PURE__*/_react.default.createElement(_ImageBrowse.ImageBrowse, {
    ref: imageBrowserRef,
    accept: acceptableMimeTypes.join(","),
    clientId: clientId,
    buttonAppearance: "secondary",
    buttonSize: usageType === "image" ? "normal" : "small",
    browseButtonTextId: "Change",
    isDisabled: isDisabled,
    onChange: onChange,
    onOpenBrowser: handleOpenBrowser,
    onCloseBrowser: handleCloseBrowser
  })));
};
exports.UploadedImageShow = UploadedImageShow;
//# sourceMappingURL=UploadedImageShow.js.map